"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _donutChartModule = _interopRequireDefault(require("./sass/donutChart.module.scss"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _recharts = require("recharts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DonutChart = function DonutChart(_ref) {
  var _donutChartClasses;

  var data = _ref.data,
      colors = _ref.colors,
      dataKey = _ref.dataKey,
      nameCenter = _ref.nameCenter,
      amount = _ref.amount,
      className = _ref.className;
  var donutChartClasses = (_donutChartClasses = {}, _defineProperty(_donutChartClasses, _donutChartModule.default.donutChart, true), _defineProperty(_donutChartClasses, className, className), _donutChartClasses);

  var renderLegend = function renderLegend() {
    return /*#__PURE__*/_react.default.createElement("ul", {
      className: _donutChartModule.default.legends
    }, data.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: index,
        className: _donutChartModule.default.legends_item
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _donutChartModule.default.legends_bullet,
        style: {
          background: colors[index]
        }
      }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: _donutChartModule.default.legends_name
      }, item.name), /*#__PURE__*/_react.default.createElement("div", {
        className: _donutChartModule.default.legends_value
      }, item.value, "%")));
    }));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(donutChartClasses)
  }, /*#__PURE__*/_react.default.createElement(_recharts.ResponsiveContainer, {
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_recharts.PieChart, null, /*#__PURE__*/_react.default.createElement(_recharts.Pie, {
    data: data,
    dataKey: dataKey,
    innerRadius: 70,
    outerRadius: 90,
    startAngle: 90,
    endAngle: 450
  }, data.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement(_recharts.Cell, {
      key: "cell-".concat(index),
      fill: colors[index % colors.length]
    });
  })), /*#__PURE__*/_react.default.createElement(_recharts.Legend, {
    content: renderLegend
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _donutChartModule.default.donutChart_center
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, nameCenter), /*#__PURE__*/_react.default.createElement("h4", null, amount))));
};

DonutChart.propTypes = {
  data: _propTypes.default.array,
  colors: _propTypes.default.array,
  dataKey: _propTypes.default.string,
  nameCenter: _propTypes.default.string,
  amount: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  className: _propTypes.default.string
};
var _default = DonutChart;
exports.default = _default;